<template>
    <b-row
        class="project-member-item d-flex align-items-center py-2 pl-sm-2 pr-0"
        no-gutters
    >
            <b-col
                cols="6"
                class="align-items-center text-truncate"
            >
                <storage-avatar
                    class="mr-2"
                    :user="projectMemberAppResource.user"
                />
                <span>
                    {{ projectMemberAppResource.user.fullName }}
                </span>
            </b-col>
            <b-col
                cols="5"
                class="text-gray-800 text-truncate"
            >
                {{ projectMemberAppResource.workspaceMembershipType.name }}
            </b-col>
            <b-col cols="1 text-right">
                <b-button
                    variant="link"
                    class="px-2"
                    size="sm"
                    @click.stop="removeItem"
                >
                    <i class="fas fa-times-circle text-red font-size-lg" />
                </b-button>
            </b-col>
    </b-row>
</template>

<script>
    import './ProjectMemberItem.scss';
    import WorkspaceOrganizationMemberAppResource
        from '@milestoneslabs/milestones-core-js/src/AppResources/WorkspaceOrganizationMemberAppResource';

    import StorageAvatar from "../../../StorageImage/StorageAvatar";

    export default {
        name: "ProjectMemberItem",

        components: {
            StorageAvatar,
        },

        props: {
            projectMemberAppResource: {
                type: WorkspaceOrganizationMemberAppResource,
                required: true,
            },
        },

        methods: {
            removeItem() {
                this.$emit('remove', this.projectMemberAppResource);
            },
        }
    };
</script>
